import * as React from 'react';
import isNumber from 'lodash/isnumber';
import { ValidationLevel } from 'ui';
import { LoadOptions } from 'app/types-shared';
import { codePickersId, CodeCodetablePickerProps } from './types';
import { CodeFieldWireKey } from 'app/area/indicator-factors/types-store';
import { SinglePickerCreator } from 'app/area/indicator-factors/common/single-picker-creator';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { getDisabledValidation } from 'app/area/shared/codetable/item/codetable-item-helpers';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const IndicatorSubstance = (props: CodeCodetablePickerProps) => {

  const { breadcrumbs, codeItem, codetableOptions, loadCodetableOptions, translation, validation, readOnly } = props;

  const codetableId = codePickersId.substance;
  const codetableKey = CodeFieldWireKey.indicatorSubstance;
  const substanceCategoryKey = CodeFieldWireKey.indicatorSubstanceCategory;

  const substanceCategoryId = codePickersId.substanceCategory;
  const indicatorSubstanceValue = codeItem?.[codetableKey];
  const indicatorSubstanceCategoryValue = codeItem?.[substanceCategoryKey];
  const indicatorSubstanceCategoryKey = CodeFieldWireKey.indicatorSubstanceCategory;
  const indicatorSubstanceUomKey = CodeFieldWireKey.indicatorSubstanceUom;

  const substanceCategory = codeItem?.[indicatorSubstanceCategoryKey]?.value ?? codeItem?.[codetableKey]?.category?.value;

  const limitFieldsTo = [CodeFieldWireKey.code, CodeFieldWireKey.defaultUomType, CodeFieldWireKey.category];

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadCodetableOptions(id, codetableId, loadOptionsParams, { limitFieldsTo });
  };

  const onLoadCategoryOptions = (loadOptionsParams: LoadOptions) => {
    loadCodetableOptions(indicatorSubstanceCategoryKey, substanceCategoryId, loadOptionsParams, { limitFieldsTo });
  };

  const categoryOptions = codetableOptions?.[indicatorSubstanceCategoryKey]?.codes ?? [];

  const onChange = (value: CodeComplexValue<number>) => {
    props.resetValidation(codetableKey, value);
    props.resetValidation(indicatorSubstanceUomKey, undefined);
    props.onChange(codetableKey, value);
    props.onChange(indicatorSubstanceCategoryKey, isDefinedIncludingZero(value?.category?.value)
      ? value.category : { value: value?.categoryId });
    props.onChange(indicatorSubstanceUomKey, undefined);
    props.clearAllValidation(codetableKey);
  };

  const uomTypeIndicatorCurrentOptions = codetableOptions[CodeFieldWireKey.uomTypeIndicator]?.currentOptions;
  const uomTypeIndicatorOptions = uomTypeIndicatorCurrentOptions?.length > 0 && uomTypeIndicatorCurrentOptions[0];
  const uomTypeIndicator = uomTypeIndicatorOptions?.uomTypeIndicator;
  const standardUomSet = uomTypeIndicatorOptions?.uomSet;

  const uomTypeIndicatorValidation = (!!indicatorSubstanceValue && isNumber(uomTypeIndicator?.value) && uomTypeIndicator?.value === 0) ? {
    level: ValidationLevel.warning, messages: [{
      level: ValidationLevel.warning,
      message: replaceTemplateString(
        translation.indicatorSubstanceWarningText,
        uomTypeIndicator?.description,
        standardUomSet?.description
      )
    }]
  } : {
    ...getDisabledValidation(indicatorSubstanceValue?.disabled, translation.selected_value_disabled),
    ...getDisabledValidation(indicatorSubstanceCategoryValue?.disabled, translation.selected_value_disabled)
  };

  const currentValidation = !!validation && !!validation[codetableKey] ? validation[codetableKey] : undefined;
  const finalValidation = { ...currentValidation, ...uomTypeIndicatorValidation };

  const indicatorSubstanceManageOptionsButton = manageOptionsButton(translation.manage_options, codetableId, breadcrumbs);

  const valueItem = {
    ...indicatorSubstanceValue,
    categoryId: indicatorSubstanceValue?.categoryId ?? indicatorSubstanceValue?.category?.value
  };

  return <SinglePickerCreator
    id={codetableKey}
    label={translation.indicatorSubstance}
    valueItem={valueItem}
    searchRequired={false}
    required={!readOnly}
    readOnly={readOnly}
    options={codetableOptions?.[codetableKey]?.codes}
    fetchingOptions={codetableOptions[codetableKey] && codetableOptions[codetableKey].fetching}
    translation={translation}
    onLoadOptions={onLoadOptions}
    onChange={onChange}
    extraFooterButton={indicatorSubstanceManageOptionsButton}
    validation={finalValidation}
    enableMultilineValidation={true}
    displayCategories={true}
    onLoadCategoryOptions={onLoadCategoryOptions}
    categoryOptions={categoryOptions}
    categoryId={substanceCategory}
  />;
};
